import { MetricGrouping, MetricIntervalPeriod } from '@/types/agentEvents';
import { defaultOccupancyParams } from '@/utils/metricsParams';
import { shouldShowAgentPerformanceIntervalChart } from '@/utils/agentMetricIntervalView';
import { parseHHMMSSToSeconds } from '@/utils/metricsAggregate';
import { MetricsSection } from '../dashboard/MetricsSection';
import { MetricCard } from '../common/MetricCard';
import { MetricIntervalNumericLineChart } from '../common/MetricIntervalNumericLineChart';
import { api } from '@/store/api';
import { Box } from '@gapartners/ui';
import { useAppSelector } from '@/store/hooks';

export function AgentAverageHoldTimeSection() {
  const { user } = useAppSelector(state => state.auth);
  return (
    <MetricsSection
      titleKey="metrics.averageHoldTime.title"
      descriptionKey="metrics.averageHoldTime.description"
      metricName="average-hold-time"
      defaultParams={{
        ...defaultOccupancyParams(),
        groupings: [MetricGrouping.AGENT],
        intervalPeriod: MetricIntervalPeriod.TOTAL,
      }}
      useQuery={api.useGetAgentAverageHoldTimeMetricsQuery}
      groupingsOptions={[MetricGrouping.AGENT]}
      renderData={({ data, params }) => {
        const myMetrics = data.filter(
          item => item.dimensionLabels?.AGENT === user?.email
        );

        const showIntervalChart = shouldShowAgentPerformanceIntervalChart(
          params.intervalPeriod,
          myMetrics
        );

        if (showIntervalChart) {
          return (
            <Box sx={{ width: '100%', minHeight: 300, mt: 1 }}>
              <MetricIntervalNumericLineChart
                data={myMetrics}
                valueToNumber={parseHHMMSSToSeconds}
                valueFormatter={v => String(v)}
                height={300}
              />
            </Box>
          );
        }

        return (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                md: 'repeat(2, 1fr)',
                lg: 'repeat(3, 1fr)',
                xl: 'repeat(5, 1fr)',
              },
              gap: 2,
            }}
          >
            {myMetrics.map(item => (
              <MetricCard
                key={item.id}
                title={item.dimensionLabels?.AGENT ?? item.name ?? 'N/A'}
                value={String(item.value)}
              />
            ))}
          </Box>
        );
      }}
    />
  );
}
